import toastr from 'toastr';

const success = (message) => {
    toastr.success(message, 'Success');
};

const error = (message) => {
    toastr.error(message, 'Error');
};

export default {
    success,
    error,
};
